import { Hero } from '@/components/home/Hero';
import { CustomersReviews } from '@/components/shared/CustomersReviews';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { SectionEventWrapper } from '@/components/shared/SectionEventWrapper';
import type { Config } from '@/pageConfig/home';
import { LEMONADE_PAGE } from '@/utils/productAdaPages';
import dynamic from 'next/dynamic';
import type React from 'react';

const Prices = dynamic(() => import('@/components/shared/Prices').then(mod => mod.Prices));
const GenericProducts = dynamic(() => import('@/components/shared/GenericProducts').then(mod => mod.GenericProducts));
const Products = dynamic(() => import('@/components/shared/Products').then(mod => mod.Products));
const Switching = dynamic(() => import('@/components/shared/Switching').then(mod => mod.Switching));
const SuperCharge = dynamic(() => import('@/components/home/SuperCharge/SuperCharge').then(mod => mod.SuperCharge));
const HowItWorks = dynamic(() => import('@/components/shared/HowItWorks').then(mod => mod.HowItWorks));
const SwitchingEurope = dynamic(() => import('@/components/home/SwitchingEurope').then(mod => mod.SwitchingEurope));
const Trust = dynamic(() => import('@/components/shared/Trust').then(mod => mod.Trust));
const InstantEverything = dynamic(() =>
  import('@/components/shared/InstantEverything').then(mod => mod.InstantEverything),
);

const componentsByName = {
  hero: Hero,
  customersReviews: CustomersReviews,
  instantEverything: InstantEverything,
  prices: Prices,
  genericProducts: GenericProducts,
  products: Products,
  frProducts: Products,
  switching: Switching,
  superCharge: SuperCharge,
  howItWorks: HowItWorks,
  trust: Trust,
  switchingEurope: SwitchingEurope,
} as const;

interface HomeTemplateProps {
  config: Config;
}

export const HomePageTemplate: React.FC<HomeTemplateProps> = ({ config }) => {
  return (
    <Layout page={LEMONADE_PAGE} {...config.layout}>
      <SEO {...config.seo} />

      {Object.entries(config).map(([componentName, componentProps]) => {
        if (componentName === 'seo' || componentName === 'layout') return null;

        const Component = componentsByName[componentName as keyof typeof componentsByName];

        if (Component == null) {
          console.error(`Component ${componentName} not found`);
          return null;
        }

        return (
          <SectionEventWrapper key={componentName} name={componentName} page="home">
            <Component {...componentProps} {...componentProps.layout} />
          </SectionEventWrapper>
        );
      })}
    </Layout>
  );
};
